import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activityMediaCatalogRoutes: MenuInterface[] = [
    {
        code: 'MediaCatalog',
        route: [
            {
                content: '$type/settings/media-catalog/list',
                focus: 'empty',
            },
            {
                primaryRoute: 'content',
                queryParams: {closeButton: 1}
            }
        ],
    },
    {
        code: 'MediaFamily',
        route: [
            {
                content: '$type/settings/media-catalog/families/list',
                focus: 'empty',
            },
            {
                primaryRoute: 'content',
                queryParams: {closeButton: 1}
            }
        ],
    },
    {
        code: 'MediaCatalogImport',
        route: [
            {
                content: '$type/settings/media-catalog/import',
                focus: 'empty',
            },
            {
                primaryRoute: 'content',
                queryParams: {closeButton: 1}
            }
        ],
    },
];
